var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M19.8 7.8h-3.2c-.6 0-1.2-.5-1.2-1.2V4c0-.4.3-.8.8-.8.4 0 .8.1 1 .4l2.7 2.3q.6.45.6 1.2c0 .2-.1.4-.2.5-.2.1-.3.2-.5.2m-3.4-3.5v2.3c0 .1.1.2.2.2h2.8l-.1-.1-2.7-2.3c-.1 0-.1-.1-.2-.1m-.2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18.7 22.8H7.5c-1.1 0-2-.9-2-2V5.2c0-1.1.9-2 2-2H14v4.2c0 .9.7 1.6 1.6 1.6h4.9v12c0 1-.8 1.8-1.8 1.8M7.5 4.2c-.5 0-1 .4-1 1v15.5c0 .5.4 1 1 1h11.2c.4 0 .8-.3.8-.8V10h-3.9C14.2 10 13 8.9 13 7.4V4.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M8.7 19.7c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l2.7-3.7c.3-.4.8-.5 1.2-.2l1.8 1.1h.2l2.2-3.4c.2-.2.5-.3.7-.2s.3.5.2.7l-2.2 3.4c-.3.5-1 .7-1.5.4l-1.8-1.1-2.7 3.6c-.1.1-.2.2-.4.2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M17.6 14.8c-.2 0-.4-.1-.5-.4l-.4-1.3-1.4.4c-.3.1-.5-.1-.6-.3-.1-.3.1-.5.3-.6l2.4-.7.7 2.3c.1.3-.1.5-.3.6z"
})));
export default SvgReports;